<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;">
                <template v-if="!(typeof(actionData.couponslist_add) != 'undefined'&&!actionData.couponslist_add)">
                    <el-button size="medium" type="primary" icon="el-icon-plus" @click="addCouponsPush">添加</el-button>
                </template>
                <span v-else style="color: #f9fafc;">空</span>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="670"
            border
            v-loading="listLoading" 
            >
            <!-- 
                "vue/no-unused-vars": "warn"
                使用// eslint-disable-next-line忽略下一行。
                使用/* eslint-disable */忽略文件中的所有警告。
            -->
            <!-- eslint-disable  -->
            <el-table-column label="优惠券编号">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SerialNumber" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SerialNumber || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券名称" >
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Name" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Name || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券类型">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.CouponType" placeholder="请选择优惠券类型" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.COUPONTYPE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CouponTypeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="发放方式">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.GiveOutMode" placeholder="请选择发放方式" style="width: 100%;">
                            <el-option :value="item.value" :label="item.label" v-for="(item, index) in COUPONS_TYPE.GIVEOUTMODE" :key="index"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.GiveOutModeName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="有效期">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.EffectivityTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span v-if="scope.row.EffectivityStartTime && scope.row.EffectivityEndTime">{{scope.row.EffectivityStartTime}}至{{scope.row.EffectivityEndTime}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="优惠券总数">
                <el-table-column show-overflow-tooltip width="160">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.TotalCount" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.TotalCount || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="已使用数量">
                <el-table-column show-overflow-tooltip width="160">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.UsedCount" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.UsedCount || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="状态">
                <el-table-column show-overflow-tooltip width="160">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.Status" placeholder="请选择状态" style="width: 100%;">
                            <el-option :value="1" label="未启用"></el-option>
                            <el-option :value="2" label="启用中"></el-option>
                            <el-option :value="3" label="启用"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.StatusName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="创建人">
                <el-table-column show-overflow-tooltip width="160">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.CreateAccountName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateAccountName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="创建时间">
                <el-table-column show-overflow-tooltip width="250">
                    <template slot="header" slot-scope="scope">
                        <el-date-picker
                            size="mini"
                            v-model="form.CreateTime"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="—"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 100%;"
                        ></el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.CreateTime || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                    <template v-if="!(typeof(actionData.couponslist_release) != 'undefined'&&!actionData.couponslist_release)">
                        <el-button v-if="scope.row.IsCanPublish" size="mini" type="primary" @click="clickIsPublish(scope.row)">发布</el-button>
                    </template>
                    <el-tag v-if="!scope.row.IsCanPublish" type="success">已发布</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageNo"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { COUPONS_TYPE } from '@/config/const/common.js'
import { 
  getStorageToken,
  getActionData
} from '@/utils/store'
import {
    couponsList,            //优惠券列表
    couponsConfig,          //发布
} from "@/service/coupons";
  export default {
    data() {
        return {
            actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用

            COUPONS_TYPE,
            listLoading: false,
            form: {
                PageNo: 1,
                PageSize: 10,


                SerialNumber: '',   //编号
                Name: '',           //名称
                CouponType: '',     //优惠券类型 1.发单 2.课程 3.通用
                GiveOutMode: '',    //发放方式 1.系统发放 2.手动领取 3.活动触发
                EffectivityTime: [],    //有效期
                TotalCount: '',         //优惠券总数
                UsedCount: '',          //使用数量
                Status: '',             //状态
                CreateAccountName: '',  //创建人
                CreateTime: [],         //创建时间

            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数

            
            tableData:[],

            personalNumber: 0,
            enterpriseNumber: 0,
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageNo = val
            this.searchData.PageNo = val
            this.GetCouponsList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageNo = 1
            this.form.PageSize = val
            this.searchData.PageNo = 1
            this.searchData.PageSize = val
            this.GetCouponsList()
        },
        async GetCouponsList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))
            !data.SerialNumber && delete data.SerialNumber
            !data.Name && delete data.Name
            !data.CouponType && delete data.CouponType
            !data.GiveOutMode && delete data.GiveOutMode
            !data.TotalCount && delete data.TotalCount
            !data.UsedCount && delete data.UsedCount
            !data.Status && delete data.Status
            !data.CreateAccountName && delete data.CreateAccountName
            if(data.EffectivityTime && data.EffectivityTime.length) {
                data.EffectivityStartTime = data.EffectivityTime[0]
                data.EffectivityEndTime = data.EffectivityTime[1]
            }
            delete data.EffectivityTime
            if(data.CreateTime && data.CreateTime.length) {
                data.CreateStartTime = data.CreateTime[0]
                data.CreateEndTime = data.CreateTime[1]
            }
            delete data.CreateTime
            data.Token = getStorageToken();
            data.platform = 'pcweb'
            let res = await couponsList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows

            this.personalNumber = res.Data.UserAddedCount
            this.enterpriseNumber = res.Data.CompanyAddedCount
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        clickIsPublish(rows){
            let data = {
                "OperationType": 3,
                "Id": rows.Id,
                "Token": getStorageToken(),
                "platform":"pcweb"
            }
            couponsConfig(data).then((res)=>{
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.handleSearch()
            })
        },
        // 点击添加
      addCouponsPush() {
        this.$router.push('/coupons/addCoupons?personalNumber='+this.personalNumber+'&enterpriseNumber='+ this.enterpriseNumber)
      }
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>